
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { configStore } from "@/store/store-accessor";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import Icon from "@/components/UI/Icon.vue";
import { getFrontendUrl } from "@/lib/document";
import clipboardCopy from "clipboard-copy";

@Component({
  components: {
    Icon,
    Dropdown,
    IconButton,
    TopBarSection
  }
})
export default class Exit extends Vue {
  isOpen = false;

  get backToAdmin() {
    if (configStore.documentSpecificNeededUrls) {
      return configStore.documentSpecificNeededUrls.backToWordPressUrl;
    }

    return "";
  }

  get backToFrontend() {
    return getFrontendUrl();
  }

  get builderMode() {
    return configStore.builderMode;
  }

  get nudgeTop() {
    return this.builderMode === "oxygen" ? -16 : 0;
  }

  get nudgeLeft() {
    return this.builderMode === "oxygen" ? 7 : 0;
  }

  copyFrontEndLinkToClipboard() {
    if (this.backToFrontend) {
      clipboardCopy(this.backToFrontend);
    }
  }
}
